<!--
 * @Description: 常规工作/日常事务 请假
 * @Author: 王赵坤
 * @Date: 2022-12-28 15:57:15
 * @LastEditors: PF
 * @LastEditTime: 2025-02-13 16:48:51
 * @FilePath: \VUE3\src\components\home\tingkejilu.vue
-->
<template>
  <div>
    <el-dialog class="wp90 h800" :model-value="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Suitcase />
          </el-icon>
          <span class="header-title">校历课表</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-header>
            <!-- 搜索区域 BEGIN -->
            <el-form class="search-box mb0">
              <el-form-item >
                <el-select v-model="xqid" placeholder="学期" style="width:100px" @change="caxxvn();getzouci()">
                  <el-option v-for="(item) in allXq" :key="item.id" :label="item.xqmc" :value="item.id" />
                </el-select>
              </el-form-item>
              <el-form-item >
                <el-select v-model="zcid" placeholder="周次" style="width:100px" @change="handleNodeClick()">
                  <el-option v-for="item in allzc" :key="item.id" :label="'第'+item.zc+'周'" :value="item.zc" />
                </el-select>
              </el-form-item>
            </el-form>
            <!-- 搜索区域 END -->
            <!-- 按钮区域 BEGIN -->
            <div class="button-box mb0">
              <el-button type="primary">导出班级课表</el-button>
              <el-button type="primary">导出教师课表</el-button>
              <el-button type="primary">导出教室课表</el-button>
              <el-button type="success">一键导出全部课表</el-button>
            </div>
            <!-- 按钮区域 END -->
          </el-header>
          <el-container style="height: calc(100% - 107px);">
            <el-aside width="200px">
              <el-row>
                <el-col :span="24">
                  <el-select v-model="cxtj">
                    <el-option label="班级课表" :value=2 />
                    <el-option label="教师课表" :value=1 />
                    <el-option label="教学场地课表" :value=3 />
                  </el-select>
                </el-col>
                <el-col :span="24" style="margin-top:10px;">
                  <!-- 机构 -->
                  <el-select v-model="sxtj" placeholder="Select" @change="sxtjget" v-show="cxtj==1">
                    <el-option label="全部机构" :value="1" />
                    <el-option label="未设置机构" :value="0" />
                    <el-option v-for="item in jigoulist" :key="item.id" :label="item.jgmc" :value="item.id" />
                  </el-select>
                  <!-- 专业 -->
                  <el-select v-model="sxtj" placeholder="Select" @change="sxtjget" v-show="cxtj==2">
                    <el-option label="全部专业" :value="2" />
                    <el-option v-for="item in zylist" :key="item.id" :label="item.zymc" :value="item.id" />
                  </el-select>
                  <!-- 教学楼 -->
                  <el-select v-model="sxtj" placeholder="Select" @change="sxtjget" v-show="cxtj==3">
                    <el-option label="全部教学楼" :value="3" />
                    <el-option label="未设置教学楼" :value="0" />
                    <el-option v-for="item in jzwlist" :key="item.id" :label="item.jzwmc" :value="item.id" />
                  </el-select>
                </el-col>
                <el-col :span="24" style="margin-top:10px;">
                  <el-input v-model="keyword" placeholder="请输入内容" @change="caxxvn" class="input-with-select">
                    <template #append>
                      <el-button :icon="Search" />
                    </template>
                  </el-input>
                </el-col>
                <el-col :span="24">
                  <el-scrollbar style="height:100%;font-size: 14px;" height="600px">
                    <el-tree :data="jzgsall" default-expand-all highlight-current :props="defaultProps" v-show="cxtj==1" @node-click="handleNodeClick" />
                    <el-tree :data="bjsall" default-expand-all highlight-current :props="defaultPropsbj" v-show="cxtj==2" @node-click="handleNodeClick" />
                    <el-tree :data="jxcdsall" default-expand-all highlight-current :props="defaultPropsjxcd" v-show="cxtj==3" @node-click="handleNodeClick" />
                  </el-scrollbar>
                </el-col>
              </el-row>
            </el-aside>
            <el-main>
              <div class="operation-total" v-if="cxtj==2">
                <span style="font-size: 16px;">{{bjform.mc}}</span>
                <span style="font-size: 16px;">班主任：{{bjform.zxs}}</span>
                <span style="font-size: 16px;">年级:{{bjform.ypxs}}</span>
                <span style="font-size: 16px;">专业:{{bjform.syxs}}</span>
              </div>
              <div class="box">
                <banJiKeBiao :bilistdata="bilistdata" :xqid="xqid" :bjloading="bjloading" :zcid="zcid" @falseloding="falsebjloading" @chuanshujvxl="chuanshujvxl" :bjid="bjid" v-show="cxtj==2" />
                <jiaoShiKebiao :jslistdata="jslistdata" :xqid="xqid" :zcid="zcid" v-show="cxtj==1" @chuanshujvxl="chuanshujvxl" />
                <jiaoXveChangDikebiao :jxcdlistdata="jxcdlistdata" :xqid="xqid" :zcid="zcid" v-show="cxtj==3" @chuanshujvxl="chuanshujvxl" />
              </div>
            </el-main>
          </el-container>
        </el-container>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, watch, defineEmits, ref } from 'vue'
import banJiKeBiao from './paikerenwu/xiaolibanjikebiao.vue' // 班级课表
import jiaoShiKebiao from './paikerenwu/xiaolijiaoshikebiao.vue' // 教师课表
import jiaoXveChangDikebiao from './paikerenwu/xiaolijiaoxvechangdikebiao.vue' // 教学场地课表
import { loadSelect, actionPost, homeCloseWindow } from '@/api/common.js'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

// 内容区域 开始
const bjloading = ref(false)
const cxtj = ref(2) // 查询条件
const sxtj = ref() // 筛选条件
const xqid = ref('') // 学期id
const zcid = ref('') // 周次 id
const allXq = ref() // 学期
const allzc = ref() // 周次
const jzgsall = ref() // 教师树形控件
const bjsall = ref() // 班级树
const jxcdsall = ref() // 教学场地
const zylist = ref() // 专业
const jzwlist = ref() // 建筑物
const jigoulist = ref() // 机构
const bjid = ref() // 班级id
const jzgid = ref() // 教职工id
const jxcdid = ref() // 教学场地id
const bilistdata = ref() // 班级数据
const jslistdata = ref() // 教师数据
const jxcdlistdata = ref() // 教学场地数据
const keyword = ref() // 关键字查询
const bjform = ref({
  syxs: '',
  ypxs: '',
  zxs: ''
}) // 班级总学时
// 内容区域 结束

// 方法区域 开始
// 添加

// 获取学期数据
// 查询班级学生
const defaultProps = {
  children: 'children',
  label: 'xm'
}
// 班级树形控件
const defaultPropsbj = {
  children: 'children',
  label: 'mc'
}
// 教学场地树形控件
const defaultPropsjxcd = {
  children: 'children',
  label: 'jsmc'
}
// const falsebjloading = () => {
//   bjloading.value = false
// }
// 传数据
const gochuanshujvxl = (val, time, number) => {
  emits('gochuanshujvxl', val, time, number)
}
const chuanshujvxl = (val, time, number) => {
  gochuanshujvxl(val, time, number)
}
// 获取学期数据
const getxqlist = () => {
  loadSelect({
    url: '/api/v2/pdp/xueqi/list',
    data: allXq,
    order: 'sx',
    sort: 'asc',
    loadSuccess: function (res) {
      res.data.forEach((element) => {
        if (element.sfdqxq === true) {
          xqid.value = element.id
        }
      })
      getzouci()
      sxtjget()
    }
  })
}
// 获取周次
const getzouci = () => {
  const o = {
    url: '/api/v2/jiaowu/jiaowuxiaoli/xiaoLiRiQi',
    data: {
      xqid: xqid.value
    }
  }
  const zcs = []
  allzc.value = []
  actionPost(o).then((res) => {
    res.data.forEach((item) => {
      if (zcs.indexOf(item.zc) === -1) {
        zcs.push(item.zc)
        allzc.value.push(item)
      }
    })
    zcid.value = res.data[0].zc
  })
}
// 专业
const zylistall = () => {
  actionPost({
    url: '/api/v2/pdp/zhuanye/list',
    data: {}
  }).then((res) => {
    zylist.value = res.data
  })
}
// 机构
const jigouall = () => {
  actionPost({
    url: '/api/v2/xiaoneijigou/list',
    data: {}
  }).then((res) => {
    jigoulist.value = res.data
  })
}
// 班级树
const bjall = () => {
  let obj = {}
  if (sxtj.value === 1 || sxtj.value === 2 || sxtj.value === 3) {
    obj = { xqid: xqid.value, keyword: keyword.value }
  } else {
    obj = { xqid: xqid.value, keyword: keyword.value, zyid: sxtj.value }
  }
  actionPost({
    url: '/api/v2/pdp/banji/tree/by_nianji',
    data: obj
  }).then((res) => {
    bjsall.value = res.data
  })
}
// 教职工树
const jzgall = () => {
  let obj = {}
  if (sxtj.value === 1 || sxtj.value === 2 || sxtj.value === 3) {
    obj = { xm: keyword.value }
  } else {
    obj = { jgid: sxtj.value, xm: keyword.value }
  }
  actionPost({
    url: '/api/v2/pdp/jiaozhigong/tree/by_jigou_binglie',
    data: obj
  }).then((res) => {
    jzgsall.value = res.data
  })
}
// 教学场地树
const jxcdall = () => {
  let obj = {}
  if (sxtj.value === 1 || sxtj.value === 2 || sxtj.value === 3) {
    obj = { jsmc: keyword.value }
  } else {
    obj = { jzwid: sxtj.value, jsmc: keyword.value }
  }
  actionPost({
    url: '/api/v2/zichan/jiaoxuechangdi/tree/by_jianzhuwu',
    data: obj
  }).then((res) => {
    jxcdsall.value = res.data
  })
}
// 建筑物
const jzwall = () => {
  actionPost({
    url: '/api/v2/zichan/jianzhuwu/list',
    data: {}
  }).then((res) => {
    jzwlist.value = res.data
  })
}
// 筛选条件查询
const sxtjget = () => {
  if (cxtj.value === 1) {
    jzgall()
  } else if (cxtj.value === 2) {
    bjall()
  } else if (cxtj.value === 3) {
    jxcdall()
  }
}
// 班级课表结构数据
const getbjlistdata = () => {
  actionPost({
    url: '/api/v2/jiaowu/jiaowuxiaolikebiao/banji',
    data: { bjid: bjid.value, xqid: xqid.value, zc: zcid.value }
  }).then((res) => {
    bilistdata.value = res.data
  })
}
// 教师课表结构数据
const getjslistdata = () => {
  actionPost({
    url: '/api/v2/jiaowu/jiaowuxiaolikebiao/zhidingjiaoshi',
    data: { jsid: jzgid.value, xqid: xqid.value, zc: zcid.value }
  }).then((res) => {
    jslistdata.value = res.data
  })
}
// 教学场地课表结构数据
const getjxcdlistdata = () => {
  actionPost({
    url: '/api/v2/jiaowu/jiaowuxiaolikebiao/jiaoixuechangdi',
    data: { jxcdid: jxcdid.value, xqid: xqid.value, zc: zcid.value }
  }).then((res) => {
    jxcdlistdata.value = res.data
  })
}
// 查询关键字
const caxxvn = () => {
  if (cxtj.value === 1) {
    jzgall()
  } else if (cxtj.value === 2) {
    bjall()
  } else if (cxtj.value === 3) {
    jxcdall()
  }
}
// 点击树形控件
const handleNodeClick = (data) => {
  if (cxtj.value === 1) {
    jzgid.value = data.id
    bjform.value.mc = data.xm
    getjslistdata()
    jszxs()
  } else if (cxtj.value === 2) {
    bjid.value = data.id
    bjform.value.mc = data.mc
    getbjlistdata()
    bjform.value.syxs = data.zymc
    bjform.value.ypxs = data.njmc
    bjform.value.zxs = data.bzrxm
    // banjizks()
  } else if (cxtj.value === 3) {
    jxcdid.value = data.id
    bjform.value.mc = data.jsmc
    getjxcdlistdata()
    jxcdzxs()
  }
}
const jszxs = () => {
  actionPost({
    url: '/api/v2/jiaowu/jiaowupaikekebiao/jiaoshikeshi',
    data: { jsid: jzgid.value }
  }).then((res) => {
    bjform.value.syxs = res.data.syxs
    bjform.value.ypxs = res.data.ypxs
    bjform.value.zxs = res.data.zxs
  })
}
const jxcdzxs = () => {
  actionPost({
    url: '/api/v2/jiaowu/jiaowupaikekebiao/jiaoxuechangdikeshi',
    data: { jxcdid: jxcdid.value }
  }).then((res) => {
    bjform.value.syxs = res.data.syxs
    bjform.value.ypxs = res.data.ypxs
    bjform.value.zxs = res.data.zxs
  })
}
const openList = ref(false)
watch(
  () => props.open,
  () => {
    if (props.open === 'banjixiaolikebiao') {
      openList.value = true
      getxqlist()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)

watch(
  () => xqid,
  () => {
    if (xqid.value) {
      bilistdata.value = []
      jslistdata.value = []
      jxcdlistdata.value = []
    }
  },
  { deep: true, immediate: true }
)
watch(
  () => cxtj,
  () => {
    if (cxtj.value) {
      getxqlist()
      //
      if (cxtj.value === 1) {
        sxtj.value = 1
        keyword.value = ''
        jigouall()
        jzgall()
      } else if (cxtj.value === 2) {
        sxtj.value = 2
        keyword.value = ''
        zylistall()
        bjall()
      } else if (cxtj.value === 3) {
        sxtj.value = 3
        keyword.value = ''
        jxcdall()
        jzwall()
      }
    }
  },
  { deep: true, immediate: true }
)
</script>

  <style lang="less" scoped>
@import '@/assets/css/publicList.less';
@import '@/assets/css/tanchuangbuju.less';
.box {
  width: 99%;
  height: 67vh;
  margin-left: 10px;
}
:deep.el-header {
  --el-header-padding: 0 0px;
  --el-header-height: 50px;
}
:deep.el-dialog__body {
  padding: 10px 20px;
}
.scrollbar-demo-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  margin: 10px;
  text-align: center;
  border-radius: 4px;
  background: var(--el-color-primary-light-9);
  color: var(--el-color-primary);
}
.operation-total {
  width: 600px;
  display: flex;
  justify-content: space-between;
  margin-left: 10px;
}
:deep.el-main {
  --el-main-padding: 0px;
}
.input-with-select .el-input-group__prepend {
  background-color: var(--el-fill-color-blank);
}
</style>
